const ProfessionalTeam = () => {
    return (
      <div>
    
      <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem] pt-[1rem]">
        <h1 className="text-[20px] font-bold">Luggage Logistics</h1>
       <p>
        Most airlines do not accept excess and overweight baggage all the time, and even when they do, 
        no promises are made about when your excess luggage would arrive at your destination. Not just that, 
        excess baggage charges are extremely high throughout the airline industry.
        </p>
        <p>
          To solve this problem, TCS offers passengers and tourists the convenience of door-to-door service 
          for moving excess and overweight baggage, saving the passengers and tourists from carrying heavy 
          luggage on crowded trains and up and down stairways.
        </p>
  
       
      </div>
    </div>
      
    );
  };
  
  export default ProfessionalTeam;
  